__turbopack_context__.v({
  "isHero": "Section-module-scss-module___UxUUa__isHero",
  "wrapper": "Section-module-scss-module___UxUUa__wrapper",
});
